export default __webpack_public_path__ + "static/media/screen1.210ca5d8.png";